<script>
import { mapState, mapGetters, mapActions } from "vuex";
import APIService from "@/services/api.service";
// import Toko from "@/models/toko";

export default {
	name: "Pengguna",
	components: {
		// CardProduk
	},
	data() {
		return {
			info: {},
			currentPage: 1,
			totalPages: 0,
			loading: true,
			optGroup: {
				superadmin: "Super Admin",
				admin: "Admin",
				kasir: "Kasir",
				gudang: "Gudang",
			},
		};
	},
	created() {
		this.findAll();
	},
	mounted() {},
	computed: {
		...mapGetters({
			countAll: "pengguna/countAll",
		}),
		...mapState({
			myData: (state) => state.pengguna.data,
		}),
		isLoading() {
			return this.$store.state.isLoading;
		},
		urlImagePengguna() {
			return (fileName) => APIService.getImagePengguna(fileName);
		},
		getJK() {
			return (jk) => (jk === "L" ? "Laki-laki" : "Perempuan");
		},
		getGroup() {
			return (key) => this.optGroup[key];
		},
	},
	methods: {
		...mapActions({
			delete: "pengguna/delete",
			resetPassword: "pengguna/reset",
		}),
		findAll() {
			this.$store.dispatch("pengguna/getAll");
		},
		refreshData() {
			this.findAll();
		},
		tambahData() {
			this.$router.push("pengguna/add");
		},
		getInfo(id) {
			this.info = this.$store.getters["pengguna/getById"](id);
		},
		setEdit(id) {
			this.$router.push("pengguna/edit/" + id);
		},		
      setReset(id) {
			this.resetPassword(id);
		},
		swalConfirm(id) {
			this.$swal({
				title: "Apakah anda yakin?",
				text: "Data tidak dapat dipulihkan kembali!",
				icon: "warning",
				showCancelButton: true,
				customClass: {
					confirmButton: "btn btn-danger m-1",
					cancelButton: "btn btn-secondary m-1",
				},
				confirmButtonText: "Ya, Hapus!",
				html: false,
				preConfirm: () => {
					return this.delete(id).then(
						(response) => {
							return Promise.resolve(response.data);
						},
						(error) => {
							return Promise.reject(error);
						}
					);
				},
			}).then((result) => {
				if (typeof result.value !== 'undefined') {
					if (result.value) {
						this.$swal("Deleted!", result.value.message, "success");
					} else {
						this.$swal("Gagal!", result.value, "danger");
					}
				}
			});
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs title="Pengguna" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col-sm-6 create-project-btn"></div>
						<div class="col-sm-6 create-project-btn">
							<div class="text-right">
								<b-button-group class="btn-group-pill">
									<b-button
										variant="primary"
										size="sm"
										@click="refreshData()"
                              v-b-tooltip.hover title="Refesh"
									>
										<div
											v-show="isLoading"
											class="spinner-border spinner-border-sm text-light"
											role="status"
											aria-hidden="true"
										></div>
										<i class="fa fa-refresh" v-show="!isLoading"></i
									></b-button>

									<b-button
										variant="primary"
										size="sm"
										@click="tambahData()"
                              v-b-tooltip.hover title="Tambah"
										><i class="fa fa-plus"></i
									></b-button>
								</b-button-group>
							</div>
						</div>
					</div>
				</div>

				<div class="card-body">
					<b-skeleton-wrapper :loading="!isLoading">
						<b-skeleton-table
							:rows="5"
							:columns="4"
							:table-props="{ bordered: true, striped: true }"
							animation="throb"
						></b-skeleton-table>
					</b-skeleton-wrapper>

					<template v-if="!isLoading">
						<v-table
							class="table b-table table-vcenter table-striped table-bordered"
							:data="myData"
							:currentPage.sync="currentPage"
							:pageSize="10"
							@totalPagesChanged="totalPages = $event"
						>
							<thead slot="head">
								<v-th
									sortKey="id"
									defaultSort="desc"
									class="text-center"
									>ID</v-th
								>
								<th>Nama</th>
								<th>Username</th>
                        <th>Jenis Kelamin</th>
                        <th>Level</th>
								<th class="text-center">Status</th>
								<th class="text-center">Action</th>
							</thead>
							<tbody slot="body" slot-scope="{ displayData }">
								<tr v-for="row in displayData" :key="row.id">
									<td class="text-center">{{ row.id }}</td>
									<td>{{ row.first_name }}</td>
                           <td>{{ row.username }}</td>
									<td>{{ getJK(row.jk) }}</td>
									<td>{{ row.group_description }}</td>
									<td class="text-center">
										<b-badge variant="success" v-if="row.active == 1">
											Aktif</b-badge
										>
										<b-badge variant="danger" v-else
											>Non Aktif</b-badge
										>
									</td>
									<td class="text-center">
										<b-btn-group>
											<b-button
												size="sm"
												variant="outline-dark"
												v-b-modal.modal-info
												@click="getInfo(row.id)"
                                    v-b-tooltip.hover title="Info"
											>
												<i class="fa fa-info"></i>
											</b-button>
											<b-button
												size="sm"
												variant="outline-dark"
												@click="setEdit(row.id)"
                                    v-b-tooltip.hover title="Edit"
                                    v-show="row.group_name != 'superadmin'"
											>
												<i class="fa fa-edit"></i>
											</b-button>											
                                 <b-button
												size="sm"
												variant="outline-dark"
												@click="setReset(row.id)"
                                    v-b-tooltip.hover title="Reset Password"
                                    v-show="row.group_name != 'superadmin'"
											>
												<i class="fa fa-refresh"></i>
											</b-button>
                                 <!-- <b-button
												size="sm"
												variant="outline-dark"
												@click="$router.push('pengguna/hakakses/' + row.id)"
                                    v-b-tooltip.hover title="Hak Akses"
                                    v-show="row.group_name != 'superadmin'"
											>
												<i class="fa fa-lock"></i>
											</b-button> -->
											<b-button
												size="sm"
												variant="danger"
												@click="swalConfirm(row.id)"
                                    v-b-tooltip.hover title="Delete"
                                     v-show="row.group_name != 'superadmin'"
											>
												<i class="fa fa-times"></i>
											</b-button>
										</b-btn-group>
									</td>
								</tr>
							</tbody>
						</v-table>
						<smart-pagination
							:currentPage.sync="currentPage"
							:totalPages="totalPages"
						/>
					</template>
				</div>
			</div>
		</div>
		<!-- Container-fluid Ends-->
		<b-modal id="modal-info" hide-footer size="lg" title="Informasi Pengguna">
			<table class="table">
				<tbody>
					<tr>
						<td>Nama</td>
						<td>:</td>
						<td>{{ this.info.first_name }}</td>
					</tr>
					<tr>
						<td>Jenis Kelamin</td>
						<td>:</td>
						<td>{{ this.getJK(this.info.jk) }}</td>
					</tr>
					<tr>
						<td>No. HP</td>
						<td>:</td>
						<td>{{ this.info.phone }}</td>
					</tr>
					<tr>
						<td>Username</td>
						<td>:</td>
						<td>{{ this.info.username }}</td>
					</tr>
					<tr>
						<td>Email</td>
						<td>:</td>
						<td>{{ this.info.email }}</td>
					</tr>
					<tr>
						<td>Level</td>
						<td>:</td>
						<td>{{ info.group_description }}</td>
					</tr>
					<tr>
						<td>Status</td>
						<td>:</td>
						<td>
							<b-badge variant="success" v-if="this.info.active == 1"
								>Aktif</b-badge
							>
							<b-badge variant="danger" v-else>Non Aktif</b-badge>
						</td>
					</tr>
					<tr>
						<td>ID</td>
						<td>:</td>
						<td>{{ info.id }}</td>
					</tr>
				</tbody>
			</table>
		</b-modal>
	</div>
</template>

<style scoped>
nav.smart-pagination {
	margin-top: 20px;
}
</style>